import { render, staticRenderFns } from "./novartis.vue?vue&type=template&id=46123e3e"
import script from "./novartis.vue?vue&type=script&lang=js"
export * from "./novartis.vue?vue&type=script&lang=js"
import style0 from "./novartis.vue?vue&type=style&index=0&id=46123e3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports